export default "__VITE_ASSET__CjEyhudD__"